import { useLocalizedText } from './localizedText';
import { TableProps } from '@amzn/awsui-components-react/polaris/table';

export type ColumnMap<T> = {
  [key: string]: (item: T) => JSX.Element | string;
};

export type ColumnData<T> = {
  columnDefinitions: TableProps.ColumnDefinition<T>[];
  columnDisplay: TableProps.ColumnDisplayProperties[];
};

export type EditableColConfig<T> = TableProps.ColumnDefinition<T>['editConfig'];

export function useTableColumns<T>(
  columnMap: ColumnMap<T>,
  tableName: string,
  namespaces: string[] = ['translation'],
  editableCols: Record<string, EditableColConfig<T>> | undefined = {}
): ColumnData<T> {
  const { t } = useLocalizedText(namespaces);

  return {
    columnDisplay: Object.keys(columnMap).map((key) => ({
      id: key,
      visible: true,
    })),
    columnDefinitions: Object.entries(columnMap).map((entry) => {
      const [key, mapValue] = entry;
      return {
        id: key,
        header: t(`${tableName}.columns.${key}`),
        editConfig:
          editableCols && Object.keys(editableCols).includes(key) ? editableCols[key] : undefined,
        // This cast is required because Object.entries converts the value to unknown, even though it is defined in the ColumnMap type
        cell: mapValue as (item: T) => JSX.Element | string,
      };
    }),
  };
}
